// extracted by mini-css-extract-plugin
module.exports = {"subway-color":"_9330de7794--subway-color--BSSfh"};